const scrollTo = (id: string, callback?: () => void) => {
  const element = document.getElementById(id) as HTMLDivElement;
  element.scrollIntoView({
    behavior: "smooth",
  });
  if (callback) callback();
};

export default scrollTo;
